import { Component, OnDestroy, OnInit } from '@angular/core';
import { Camp } from 'src/app/shared/modals/camp';
import { StoreService } from 'src/app/shared/services/store.service';

@Component({
  selector: 'app-camp-list',
  templateUrl: './camp-list.component.html',
  styleUrls: ['./camp-list.component.scss']
})
export class CampListComponent implements OnInit, OnDestroy {
  private storeSub: any;
  campList: Camp[] = [];

  constructor(    
    private storeService: StoreService,
    ) { }

  ngOnInit(): void {
    this.storeSub = this.storeService.getAllCamps().subscribe((camps: Camp[]) => {
      this.campList = camps.filter((camp: Camp) => !camp.disabled);
    });
  }

  ngOnDestroy(): void {
    this.storeSub?.unsubscribe();
  }

}
